import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';
import { TogglePanelCallback } from 'angular/custom/components/toggle-panel.component';

class TermsAndConditionsSettingsComponentCtrl implements ng.IController {
    private settings: TsoGeneralSettingsDto;
    private tsoRefId: number;
    private numberOfNetworkPointsThatHaveSpecificTerms: number;
    private loadingNetworkPointsError: boolean = false;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private errorHandler: ErrorHandler,
        private growl: Growl,
        private NetworkPoint: NetworkPointResource,
        private networkPointSearchService: any,
        private $location: ng.ILocationService
    ) {}

    $onInit() {
        this.NetworkPoint.findNetworkPoints(
            {
                specificTermsEnabled: true,
                bundled: false,
                tsoRefId: this.tsoRefId
            },
            (res: DataPageDto<NetworkPointDto>) => {
                this.numberOfNetworkPointsThatHaveSpecificTerms = res.totalSize;
            },
            (err) => {
                this.loadingNetworkPointsError = true;
            }
        );
    }

    public toggleSpecificTermsAndConditions(cb: TogglePanelCallback) {
        if (this.settings.specificConditionsEnabled) {
            this.TransmissionSystemOperator.saveSpecificConditionsEnabled(
                { id: this.tsoRefId },
                this.settings.specificConditionsEnabled,
                () => {
                    cb(true);
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                },
                (err) => {
                    cb(false);
                    this.handleError(err);
                }
            );
        } else {
            this.TransmissionSystemOperator.disableSpecificConditions(
                { id: this.tsoRefId },
                () => {
                    cb(true);
                    this.settings.specificConditionNote = '';
                    this.settings.specificConditionTitle = '';
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                },
                (err) => {
                    cb(false);
                    this.handleError(err);
                }
            );
        }
    }

    public saveSpecificConditionTitle(): ng.IPromise<any> {
        return this.TransmissionSystemOperator.saveSpecificConditionTitle(
            { id: this.tsoRefId },
            this.settings.specificConditionTitle
        ).$promise;
    }

    public saveSpecificConditionNote(): ng.IPromise<any> {
        return this.TransmissionSystemOperator.saveSpecificConditionNote(
            { id: this.tsoRefId },
            this.settings.specificConditionNote
        ).$promise;
    }

    private handleError = (err) => {
        this.settings.specificConditionsEnabled =
            !this.settings.specificConditionsEnabled;
        this.errorHandler(err);
    };
}

angular.module('app').component('pkpTermsAndConditionsSettings', {
    controller: TermsAndConditionsSettingsComponentCtrl,
    template:
        require('app/operator-settings-general/terms-and-conditions-settings.component.html'),
    bindings: {
        settings: '=',
        tsoRefId: '<'
    }
});
